import { ObjectIdStringValidationSchema } from '../../../shared/ObjectId';

export const PAGE_THEME_ID_DESCRIPTION =
  "The theme the page uses: one of your themes or a built-in one (see List themes). `themeOverrides` apply on top. Leave it out to use your store's default theme.";

export const PAGE_THEME_ID_UPDATE_DESCRIPTION =
  "The theme the page uses: one of your themes or a built-in one (see List themes). Changing it replaces all of the page's own theme settings, including order bump styling set in the dashboard, so the page looks like the theme. That drops the page's labels too, translations included: send the ones to keep in `themeOverrides` in the same request, which apply on top. The page's locale is kept.";

export const PageThemeIdInputValidationSchema = ObjectIdStringValidationSchema.optional().meta({
  description: PAGE_THEME_ID_DESCRIPTION,
});

export const UpdatePageThemeIdInputValidationSchema =
  ObjectIdStringValidationSchema.optional().meta({
    description: PAGE_THEME_ID_UPDATE_DESCRIPTION,
  });
